import React from 'react';

const IconFacebookSquare: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='26'
    viewBox='0 0 25 26'
    focusable='false'
    role='presentation'
    fill='none'
    {...props}
    className={`icon icon-facebook-square${props.className ? ' ' + props.className : ''}`}
  >
    <path
      d='M22.3214 0.5H2.67857C1.96817 0.5 1.28686 0.782206 0.784535 1.28454C0.282206 1.78687 0 2.46817 0 3.17857L0 22.8214C0 23.5318 0.282206 24.2131 0.784535 24.7155C1.28686 25.2178 1.96817 25.5 2.67857 25.5H10.3376V17.0006H6.82199V13H10.3376V9.95089C10.3376 6.4827 12.4023 4.56696 15.5647 4.56696C17.0792 4.56696 18.6629 4.83705 18.6629 4.83705V8.24107H16.918C15.1987 8.24107 14.6624 9.30804 14.6624 10.4023V13H18.5006L17.8867 17.0006H14.6624V25.5H22.3214C23.0318 25.5 23.7131 25.2178 24.2155 24.7155C24.7178 24.2131 25 23.5318 25 22.8214V3.17857C25 2.46817 24.7178 1.78687 24.2155 1.28454C23.7131 0.782206 23.0318 0.5 22.3214 0.5Z'
      fill=''
    />
  </svg>
);
export default IconFacebookSquare;
